import React from "react";
// import "./item.css";

function EmptyTodos() {
  return <p>¡Crea tu primer tarea!</p>;
}
export { EmptyTodos };



// WEBPACK FOOTER //
// ./src/emptytodos/emptytodos.js